import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Images from "../../Assets/Images/Index";
import "./Template.css";
import { Play, Search } from "lucide-react";
import axios from "axios";
import templatetop from "../../Assets/Images/template-top.png"

function Template() {
  const [templates, setTemplates] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [goal, setGoal] = useState("");
  const fetchTemplates = async () => {
    try {
      const response = await axios.get(
        "https://qflyers.minipossystem.com/api/v1/register-data"
      );
      console.log({ templates: response.data.templates });
      setTemplates(response.data.templates || []);
      setGoal(response.data.goals || [])
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);


  const getGoalName = (goalId) => {
    const goalFound = goal.find((g) => g.id === goalId);
    return goalFound ? goalFound.name : "Unknown";
  };


  const uniqueCategories = [
    "All",
    ...Array.from(
      new Set(
        templates.map((template) => getGoalName(template.goals_id))
      )
    ),
  ];

  const filteredTemplates = templates.filter((template) => {
    const goalName = getGoalName(template.goals_id);

    const matchesCategory =
      selectedCategory === "All" || goalName === selectedCategory;

    const matchesSearch = template.name
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase());

    return matchesCategory && matchesSearch;
  });


  return (
    <div>
      <Header />
      <div className="template-container">
        <div className="template-top row">
          <div className="col-lg-6 template-top-img">
            <img src={templatetop}></img>
          </div>
          <div className="col-lg-6 template-top-txt">
            <h1>Templates are created by <span>QFlyers</span> suitable for every field.</h1>
            <div>
              <ul>
                <li>Templates are created by QFlyers suitable for every field.</li>
                <li>Different Link Apps, integrations and visual styles can help you create a Linktree that looks and feels like you and your brand.</li>
                <li>Explore our library of custom templates to grow and connect with your audience even more easily!</li>
                <li>Feed Your Template</li>
                <li>Our Most Popular Templates pricing - page</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container tem-loading-cont">
          <p>Feed Your Template</p>
          <h2>Our Most <span style={{ color: "#f04b3d" }}>Popular</span> Templates</h2>
          <div className="search__container">
            <input
              type="text"
              placeholder="Search"
              className="search__box"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Search className="search__icon" />
          </div>
        </div>

        <div className="filter-container container">

          {uniqueCategories.map((category) => (
            <div
              key={category}
              className={`filter-item ${selectedCategory === category ? "active" : ""
                }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </div>
          ))}
        </div>

        <div className="em-loading-cont-img container">
          {filteredTemplates.map((template, index) => (
            <img
              key={template.id}
              src={template.image}
              alt={`Template ${index + 1}`}
              data-aos="flip-left"
              data-aos-delay={index * 100}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Template;
